module.exports = __webpack_public_path__ + "static/img/15056B_1_2_C_20210111_fit.edf26cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15056B_1_2_C_20210111_fit.png
// module id = /rh0
// module chunks = 0